import {Router, NavigationStart, Event as NavigationEvent} from '@angular/router';
import { ToastsManager } from 'ng2-toastr/ng2-toastr';
import { Logger } from 'angular2-logger/core';

import { SharedService } from '../../shared/shared.service';
import { AdminService } from '../admin.service';
import { environment } from '../../../environments/environment';
import { ViewChild, ElementRef, AfterViewInit,Component, ViewContainerRef, ViewEncapsulation, OnDestroy, HostListener, Inject, OnInit } from '@angular/core';
import {NavService} from '../nav.service';
import { MatSidenav } from '@angular/material';
import { NgxSpinnerService } from 'ngx-spinner';


@Component({
  selector: 'app-admin', 
  templateUrl: './admin.component.html',
  styleUrls: ['./admin.component.scss']
})
export class AdminComponent implements OnInit, AfterViewInit {
  @ViewChild('appDrawer') appDrawer: ElementRef;
  @ViewChild('sidenav') sidenav: MatSidenav;
  


  isExpanded = true;
  showSubmenu: boolean = false;
  isShowing = false;
  showSubSubMenu: boolean = false;
  public state_menu: boolean;
  public fade_box: boolean;
  public position: string;
  public fade_das: boolean;
  public currentUrl: string;
  public url_menu: any[] = [
    {
      'label': 'Gestionar Usuarios',
      'url': './#/admin/users'
    },
    {
      'label': 'Gestionar Horarios',
      'url': './#/admin/schedules'
    },
    {
      'label': 'Gestionar Reportes',
      'url': './#/admin/report'
    }
  ];
  public fechaa: string;

  constructor(
    private _router: Router,
    private _adminService: AdminService,
    public _sharedService: SharedService,
    public toastr: ToastsManager,
    public logger: Logger,
    private navService: NavService,
    private spinner: NgxSpinnerService,
    ) {
      let aux = new Date().toJSON().slice(0, 10).replace(/-/g, '/').split('/');
      this.fechaa = aux[2] + '/' + aux[1] + '/' + aux[0];
      this.logger.log(this._sharedService.user);
      this.position = 'a';
      //genera un evento cuando se cambia de ruta
      this._router.events.forEach((event: NavigationEvent) => {
        if(event instanceof NavigationStart) 
        {
            this.currentUrl = event.url;
            this.state_route(this.currentUrl);
        }
    });
  }

  ngOnInit() {
    this.state_route(this._router.url);
  }

  change_dash(value) {
    this.position = value;
  }

  state_dash(event) {
    console.log(event);
    this.fade_das = event;
  }

  state_route(route) {
    if( route != '/admin')
    {
      this.state_dash(true);
    }
    else {
      this.state_dash(false);
    }
  }

  mouseenter() {
    if (!this.isExpanded) {
      this.isShowing = true;
    }
  }

  mouseleave() {
    if (!this.isExpanded) {
      this.isShowing = false;
    }
  }

  ngAfterViewInit() {
    this.navService.appDrawer = this.appDrawer;
  }

  Menu(state) {
    if(this.state_menu == state)
      state= !state;
      
    this.state_menu = state;
    this.fade_box = state;
    if(state)
      this.navService.openNav();
    else
      this.navService.closeNav();

  }

  onLogout() {
    this.spinner.show();
    this._sharedService.logout().subscribe(
      data => {
        if (data.code_status === 200) {
          this.toastr.success('Has salido del sitio', 'Éxito!');
          this._sharedService.user = null;
          this.logger.log(this._sharedService.user);
          this._router.navigate(['/auth', {}]);
          this._sharedService.setCookie('auth_token', '', -1, environment.c_domain);
        } else {
          this.toastr.error(data.message, 'Error');
          this.logger.log(data);
        }
        this.spinner.hide();
      },
      error => {
        this.toastr.error('Ocurrió un error, por favor intente de nuevo', 'Error');
        this.logger.log(<any>error);
        this.spinner.hide();
      }
    );
  }

  closeMenu() {
    this.navService.closeNav();
  }

}



// WEBPACK FOOTER //
// /home/ec2-user/PasoAgentes/PA_frontend_routemobile/src/app/admin/admin/admin.component.ts